import React from "react";
import { Link } from "react-router-dom";
import "./VisitaDetailPage.css";

const VisitaOtorinolaringoiatricaPage: React.FC = () => {
  return (
    <div className="visita-detail-page">
      {/* Header Section */}
      <section className="visita-detail-header">
        <div className="visita-detail-header-container">
          <p className="visita-detail-label">VISITE SPECIALISTICHE</p>
          <h1 className="visita-detail-title">Visita Otorinolaringoiatrica</h1>
        </div>
      </section>

      {/* Content Section */}
      <section className="visita-detail-content">
        <div className="visita-detail-container">
          <img
            src={require("../assets/carousel/PHOTO-2025-10-16-20-09-05.jpg")}
            alt="Visita Otorinolaringoiatrica"
            className="visita-detail-image"
          />

          <div className="visita-detail-text">
            <h2 className="visita-detail-subtitle">
              Esame completo dell'apparato ORL
            </h2>
            <p className="visita-detail-paragraph">
              La visita otorinolaringoiatrica é una prestazione specialistica
              che ha lo scopo di individuare, monitorare e trattare le malattie
              a carico di orecchio, naso e gola. Durante la visita sono previsti
              la raccolta della storia clinica del paziente (anamnesi), l’esame
              obiettivo ed esami strumentali di approfondimento diagnostico come
              l’endoscopia, l’esame audio-impedenzometrico o l’esame
              vestibolare.
            </p>

            <div className="visita-detail-cta">
              <Link to="/#prenota" className="btn-primary">
                Prenota la Visita
              </Link>
              <Link to="/visite" className="btn-secondary">
                Torna alle Visite
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default VisitaOtorinolaringoiatricaPage;
